import { PATHNAMES } from "src/constants/routes";
import { breadCrumbsTrns } from "src/components/BreadCrumbs/trns";
import { IBreadCrumbsItem } from "src/components/BreadCrumbs/types";

export const CONTACT_US_BREADCRUMBS_ITEMS: IBreadCrumbsItem[] = [
  { title: { i18nKey: breadCrumbsTrns.home }, path: PATHNAMES.HOME },
  { title: { i18nKey: breadCrumbsTrns.contactUs } },
];
